<div style="min-height: 300px;">
    <div class="cardInner">
        <div class="presets-container">
            <!-- Shadow Presets -->
            @if (effect === 'Shadow') {
                <div class="presets-label">
                    <mat-icon>auto_awesome</mat-icon>
                    <span>{{ 'ai.shadow presets' | transloco }}</span>
                </div>
                <div class="presets-grid">
                    @for (preset of getDisplayedPresets(effect); track preset.name) {
                        <div class="preset-item" (click)="applyPreset(preset)" [title]="preset.name">
                            <div class="preset-preview shadow-preview" [style.box-shadow]="preset.preview">
                                <span class="preset-box"></span>
                            </div>
                            <div class="preset-name">{{ preset.name }}</div>
                        </div>
                    }
                </div>
            }

            <!-- Blur Presets -->
            @if (effect === 'Blur') {
                <div class="presets-label">
                    <mat-icon>blur_on</mat-icon>
                    <span>{{ 'ai.blur presets' | transloco }}</span>
                </div>
                <div class="presets-grid">
                    @for (preset of getDisplayedPresets(effect); track preset.name) {
                        <div class="preset-item" (click)="applyPreset(preset)" [title]="preset.name">
                            <div class="preset-preview blur-preview" [style.filter]="preset.preview">
                                <span class="preset-box blur-box"></span>
                            </div>
                            <div class="preset-name">{{ preset.name }}</div>
                        </div>
                    }
                </div>
            }

            <!-- Glow Presets -->
            @if (effect === 'Glow') {
                <div class="presets-label">
                    <mat-icon>flare</mat-icon>
                    <span>{{ 'ai.glow presets' | transloco }}</span>
                </div>
                <div class="presets-grid">
                    @for (preset of getDisplayedPresets(effect); track preset.name) {
                        <div class="preset-item" (click)="applyPreset(preset)" [title]="preset.name">
                            <div class="preset-preview glow-preview" [style.box-shadow]="preset.preview">
                                <span class="preset-box glow-box"></span>
                            </div>
                            <div class="preset-name">{{ preset.name }}</div>
                        </div>
                    }
                </div>
            }

            <!-- Border Presets -->
            @if (effect === 'Border') {
                <div class="presets-label">
                    <mat-icon>border_outer</mat-icon>
                    <span>{{ 'ai.border presets' | transloco }}</span>
                </div>
                <div class="presets-grid">
                    @for (preset of getDisplayedPresets(effect); track preset.name) {
                        <div class="preset-item" (click)="applyPreset(preset)" [title]="preset.name">
                            <div class="preset-preview border-preview" [style.border]="preset.preview">
                                <span class="preset-box"></span>
                            </div>
                            <div class="preset-name">{{ preset.name }}</div>
                        </div>
                    }
                </div>
            }

            <!-- Background Presets -->
            @if (effect === 'Background') {
                <div class="presets-label">
                    <mat-icon>crop_square</mat-icon>
                    <span>{{ 'ai.background presets' | transloco }}</span>
                </div>
                <div class="presets-grid">
                    @for (preset of getDisplayedPresets(effect); track preset.name) {
                        <div class="preset-item" (click)="applyPreset(preset)" [title]="preset.name">
                            <div class="preset-preview background-preview">
                                <span class="preset-box" [style.background]="preset.preview"></span>
                            </div>
                            <div class="preset-name">{{ preset.name }}</div>
                        </div>
                    }
                </div>
            }

            <!-- Gradient Presets -->
            @if (effect === 'Gradient') {
                <div class="presets-label">
                    <mat-icon>gradient</mat-icon>
                    <span>{{ 'ai.gradient presets' | transloco }}</span>
                </div>
                <div class="presets-grid">
                    @for (preset of getDisplayedPresets(effect); track preset.name) {
                        <div class="preset-item" (click)="applyPreset(preset)" [title]="preset.name">
                            <div class="preset-preview gradient-preview">
                                <span class="preset-box" [style.background]="preset.preview"></span>
                            </div>
                            <div class="preset-name">{{ preset.name }}</div>
                        </div>
                    }
                </div>
            }

            <!-- Appearance Presets -->
            @if (effect === 'Appearance') {
                <div class="presets-label">
                    <mat-icon>visibility</mat-icon>
                    <span>{{ 'ai.appearance presets' | transloco }}</span>
                </div>
                <div class="presets-grid">
                    @for (preset of getDisplayedPresets(effect); track preset.name) {
                        <div class="preset-item" (click)="applyPreset(preset)" [title]="preset.name">
                            <div class="preset-preview appearance-preview">
                                <span class="preset-box" [style.opacity]="preset.values.alpha"></span>
                            </div>
                            <div class="preset-name">{{ preset.name }}</div>
                        </div>
                    }
                </div>
            }

            <!-- Show more/less Button -->    
            <div class="show-more-container">
                <button mat-button class="show-more-btn" (click)="toggleShowAll()">
                    {{ showAll ? ('general.showLess' | transloco) : ('general.showAll' | transloco) }}
                    <mat-icon>{{ showAll ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
            </div>
        </div>

        <!-- Reset Button -->
        <!-- <div class="reset-container">
            <button mat-raised-button color="warn" class="reset-button" (click)="resetEffect()">
                <mat-icon>restore</mat-icon>
                {{ 'ai.reset' | transloco }}
            </button>
        </div> -->

        @if (dynamicsInitialized) {
            <!-- Always Visible: Color Selectors and Dropdowns -->
            @if (getColorFields().length > 0) {
                <div class="color-controls">
                    <dynamic-form [fields]="getColorFields()" (submit)="submit($event)">
                    </dynamic-form>
                </div>
            }

            <!-- Collapsible Advanced Section: Number Inputs -->
            @if (getNumberFields().length > 0 && experienceLevel > experienceLevelType.BEGINNER) {
                <div class="advanced-section">
                    <div class="advanced-toggle" (click)="toggleAdvanced()">
                        <mat-icon class="toggle-icon" [class.expanded]="showAdvanced">
                            {{ showAdvanced ? 'expand_less' : 'expand_more' }}
                        </mat-icon>
                        <span class="toggle-label">{{ 'ai.advanced settings' | transloco }}</span>
                    </div>

                    @if (showAdvanced) {
                        <div class="advanced-content" [@slideDown]>
                            <dynamic-form [fields]="getNumberFields()" (submit)="submit($event)">
                            </dynamic-form>
                        </div>
                    }
                </div>
            }
        }
    </div>
    <br />
    @if (isHostDevOrLocal) {
        <div>
            <button (click)="devExportConfig()" mat-button>export config</button>
        </div>
    }
</div>

